// base
import React, { useState, useCallback } from 'react';

// contexts
import { AlarmContext } from 'contexts';

// components
import { AlarmModal, type AlarmModalProps } from 'components';

export interface ShowAlarmProps extends Omit<AlarmModalProps, 'open' | 'onClose'> {}

export type AlarmProviderProps = React.PropsWithChildren<{}>;

export const AlarmProvider: React.FC<AlarmProviderProps> = ({ children }) => {
  const [isOpen, setIsOpen] = useState(false);
  const [modalTitle, setModalTitle] = useState<React.ReactNode | null>(null);
  const [alarmProps, setAlarmProps] = useState<ShowAlarmProps | null>(null);

  const showAlarm = useCallback((props?: ShowAlarmProps) => {
    setIsOpen(true);
    setAlarmProps(props || null);

    if (props?.modalTitle) {
      setModalTitle(props.modalTitle);
    }
  }, []);

  const closeAlarm = useCallback(() => {
    setIsOpen(false);
    setModalTitle(null);
    setAlarmProps(null);
  }, []);

  return (
    <AlarmContext.Provider
      value={{
        showAlarm,
        closeAlarm
      }}
    >
      {children}
      {isOpen && (
        <AlarmModal
          {...alarmProps}
          open={isOpen}
          onClose={closeAlarm}
          closeButtonProps={{
            className: 'close-btn',
            ...alarmProps?.closeButtonProps,
            onClick: (e) => {
              closeAlarm();
              alarmProps?.closeButtonProps?.onClick?.(e);
            }
          }}
          modalTitle={modalTitle || 'Alarm'}
        />
      )}
    </AlarmContext.Provider>
  );
};
